import React, { useEffect } from 'react';
import data from './data/content.json';
import { ContentProvider } from './context/ContentProvider';
import CONFIG from './config';
import Themes from './styles/themes';
import { StyleSheetManager, ThemeProvider } from 'styled-components';
import PageContainer from './components/PageContainer/PageContainer';
import { IContent } from './types';
import { fetchWindowVariables } from './store/features/app/app';
import { AppDispatch } from './store';
import { bindActionCreators } from 'redux';
import { connect, ConnectedProps } from 'react-redux';

type PropsFromRedux = ConnectedProps<typeof connector>;
type AppProps = PropsFromRedux &  {
    localeId: string;
};

const App = ({ localeId, fetchWindowVariables }: AppProps) => {
    const localizedContent: any = data.filter(
        locale => locale.lang === localeId
    )[0];

    useEffect(() => {
        fetchWindowVariables();
    }, []);

    return (
        <main id="cloud-unavailable-page">
            <ContentProvider value={localizedContent}>
                <ThemeProvider theme={Themes[CONFIG.isUPC ? 'Uplay' : 'Store']}>
                    <StyleSheetManager
                        target={document.querySelector('#stylesheetsContainer')}
                        disableCSSOMInjection={true}
                    >
                        <PageContainer />
                    </StyleSheetManager>
                </ThemeProvider>
            </ContentProvider>
        </main>
    );
};

const mapDisPatchToProps = (dispatch: AppDispatch) => ({
    fetchWindowVariables: bindActionCreators(fetchWindowVariables, dispatch)
});

const connector = connect(null, mapDisPatchToProps);


export default connector(App);
